import { AfterViewInit, ChangeDetectorRef, Component, Input, TemplateRef, ViewChild, inject } from '@angular/core';

@Component({
  selector: 'coro-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  standalone: false,
})
export class IconComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('leftArrow') leftArrowTemplate!: TemplateRef<any>;
  @ViewChild('rightArrow') rightArrowTemplate!: TemplateRef<any>;
  @ViewChild('upArrow') upArrowTemplate!: TemplateRef<any>;
  @ViewChild('downArrow') downArrowTemplate!: TemplateRef<any>;

  @Input() iconType!: any;
  @Input() position!: 'left' | 'right' | 'up' | 'down';

  iconTemplates: Record<string, TemplateRef<any>> = {};

  ngAfterViewInit(): void {
    // ! NOTE: `key` needs to be in the format: `${position}-${iconType}`
    this.iconTemplates = {
      'left-arrow': this.leftArrowTemplate,
      'right-arrow': this.rightArrowTemplate,
      'up-arrow': this.upArrowTemplate,
      'down-arrow': this.downArrowTemplate,
    };

    this.cdr.detectChanges();
  }
}
